import { createContext } from "react";
import type { iProvider } from "./Provider";

// Create the context with default value
const GlobalContext = createContext<iProvider | undefined>(undefined);

export default GlobalContext;
